import { useTranslation } from "react-i18next";
import React, { useState, lazy, Suspense } from "react";
import { Button, CloseOutlined } from "src/assets/imports/antdComponents";
import { IReportViewProps } from "../../models/interfaces";

// Lazy-loaded so pdfjs-dist (~413KB) is only fetched when the PDF viewer first renders.
const ReportPreview = lazy(() => import("src/components/ReportPreview"));

const ReportView: React.FC<IReportViewProps> = ({ reportName, pdfUrl, onClose, loading, setLoading, pageNo, isExpanded, handleFileDownload, handleExpand }) => {
	const { t } = useTranslation();
	const [scale, setScale] = useState(1.0);

	const handleZoomIn = () => {
		setScale((prevScale) => Math.min(prevScale + 0.2, 3.0)); // Maximum zoom scale set to 3.0
	};

	const handleZoomOut = () => {
		setScale((prevScale) => Math.max(prevScale - 0.2, 0.4)); // Minimum zoom scale set to 0.4
	};
	const handleReset = () => {
		setScale(1.0);
	};

	return (
		<div className="transcript-view">
			<div className="transcript-header">
				<div className="transcript-info">
					<div className="transcript-title text-lg font-semibold truncate-text-2-lines">{reportName}</div>
				</div>
				<div className="flex items-center">
					<div className="flex items-center mr-2 gap-2">
						{scale !== 1 && (
							<i
								title="Reset"
								onClick={handleReset}
								className={`material-symbols-outlined ${scale < 0.5 ? "tertiary-color cursor-not-allowed" : "primary-color cursor-pointer"} text-[1.8rem]`}>
								reset_focus
							</i>
						)}

						<i
							title="Zoom Out"
							onClick={handleZoomOut}
							className={`material-symbols-outlined ${scale < 0.5 ? "tertiary-color cursor-not-allowed" : "primary-color cursor-pointer"} text-[2rem]`}>
							zoom_out
						</i>

						<i title="Zoom In" onClick={handleZoomIn} className="material-symbols-outlined primary-color text-[2rem] cursor-pointer">
							zoom_in
						</i>
					</div>
					<Button onClick={handleFileDownload} icon={<i className="material-symbols-outlined primary-color text-[2rem] cursor-pointer">download</i>} type="text" />
					<i className="material-symbols-outlined text-[1.5rem] cursor-pointer text-[--secondary-color] mx-2" onClick={handleExpand}>
						{isExpanded ? "hide" : "expand_content"}
					</i>
					<CloseOutlined className="text-lg cursor-pointer ml-2" onClick={onClose} />
				</div>
			</div>
			<div className="report-body">
				<Suspense fallback={<div />}>
					<ReportPreview reportUrl={pdfUrl} pageNo={pageNo} loading={loading} setLoading={setLoading} scale={scale} />
				</Suspense>
			</div>
		</div>
	);
};

export default ReportView;
